import * as React from "react";
import { SVGProps } from "react";

const AnalyticIconSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 22}
    height={props.height || 22}
    fill="none"
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill="#9395A1"
      d="M16 16 5.608 22l-.002.001A12.003 12.003 0 0 1 16 4v12Z"
      opacity={0.2}
    />
    <path
      stroke="#9395A1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12ZM16 16V4M26.392 10 5.608 22"
    />
  </svg>
);

export default AnalyticIconSidebar;
